const getChildren = (subPath) => [
  {
    path: 'detail/:vehicleId/:customerId',
    component: () => import('@/views/lose/CustomerDetail'),
    props: (route) => {
      return {
        subPath,
        vehicleId: route.params.vehicleId,
        customerId: route.params.customerId
      }
    },
    meta: { title: '客户详情' },
    children: [
      {
        path: 'insure-detail/:id',
        component: () => import('@/views/policy/VehiclePolicyDetail'),
        props: true,
        meta: { title: '保单详情' }
      },
      {
        path: 'insure',
        component: () => import('@/views/product/ProductPre'),
        props: route => ({
          type: 'elec',
          elecInfo: {
            vehicleId: route.params.vehicleId,
            customerId: route.params.customerId
          }
        })
      }
    ]
  }
]

export default [
  {
    path: 'lose/not/allotted',
    component: () => import('@/views/lose/PageLoseNotAllotted'),
    meta: { title: '未分配流失客户' },
    children: getChildren('/lose/not/allotted')
  },
  {
    path: 'lose/allotted/self',
    component: () => import('@/views/lose/PageLoseAllottedSelf'),
    meta: { title: '已分配给我的客户' },
    children: getChildren('/lose/allotted/self')
  },
  {
    path: 'lose/allotted',
    component: () => import('@/views/lose/PageLoseAllotted'),
    meta: { title: '已分配流失客户' },
    children: getChildren('/lose/allotted')
  }
]
